import React, { useState, useRef, useEffect } from "react";

const Test = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [stream, setStream] = useState(null);
    const canvasRef = useRef(null);

    // Avvia la fotocamera
    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { ideal: 'environment' }
                }
            });
            const video = document.querySelector('video#scan');
            video.srcObject = mediaStream;
            video.removeAttribute('hidden');
            setStream(mediaStream);
        } catch (error) {
            console.error("Errore nell'accesso alla fotocamera:", error);
        }
    };

    // Cattura una foto dal video
    const capturePhoto = async () => {
        if (!canvasRef.current) return;

        const video = document.querySelector('video#scan');
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const dataURL = canvas.toDataURL("image/jpeg");
        setSelectedImage(dataURL);
        uploadToServer(dataURL);
    };

    // Quando l'utente seleziona un file
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
                uploadToServer(reader.result);
            };
            reader.readAsDataURL(file);

        }
    };

    // Invia l'immagine compressa al server
    const uploadToServer = async (file) => {
        const formData = new FormData();
        const blob = await dataURLToBlob(file);
        console.log("blob size", blob.size);
        formData.append("image", blob);
        try {
            const response = await fetch("/upload", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            console.log("Risultato del caricamento:", result);

        } catch (error) {
            console.error("Errore nell'upload dell'immagine:", error);

        }
    };

    // Funzione per convertire dataURL in Blob
    const dataURLToBlob = (dataURL) => {
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    // Disattiva la fotocamera quando il componente si smonta
    useEffect(() => {
        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [stream]);

    const getImage = async () => {
        try {
            const response = await fetch("/image");
            if (!response.ok) {
                console.error("Errore:", response.status);
                return;
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setCompressedImage(url);
            
        } catch (error) {
            console.error("Errore:", error);
        }
    };

    return (
        <div className="flex flex-col items-center p-4">
            <h2 className="text-lg font-bold mb-4">Scatta o carica un'immagine</h2>

            {/* Fotocamera */}
            <div className="relative">
                <video muted autoPlay playsInline hidden width="70%" height="70%" id="scan" className="rounded"></video>
                <canvas
                    ref={canvasRef}
                    style={{ display: 'none' }}
                    hidden
                />
                <button onClick={startCamera} className="mt-2 bg-blue-500 text-white px-4 py-2 rounded">
                    Apri Fotocamera
                </button>
                <button onClick={capturePhoto} className="mt-2 bg-green-500 text-white px-4 py-2 rounded ml-2">
                    Scatta Foto
                </button>
                <button onClick={getImage} className="mt-2 bg-green-500 text-white px-4 py-2 rounded ml-2">
                    Get Image
                </button>
            </div>

            {/* Input per il caricamento delle immagini */}
            <input type="file" accept="image/*" onChange={handleFileChange} className="mt-4" />
            <p id="sizeOr"></p>
            <p id="sizeComp"></p>

            {/* Anteprima immagine originale */}
            {selectedImage && (
                <div className="mt-4">
                    <p className="text-sm font-semibold">Anteprima originale:</p>
                    <img src={selectedImage} alt="Selected" className="w-64 h-auto rounded-md shadow-md" />
                </div>
            )}

            {compressedImage && (
                <div className="mt-4">
                    <p className="text-sm font-semibold">Anteprima compressa:</p>
                    <img src={compressedImage} alt="Compressed" className="w-64 h-auto rounded-md shadow-md" />
                </div>
            )}


        </div>
    );
};

export default Test;
